import { render, staticRenderFns } from "./DeletedOrdersSnackbar.vue?vue&type=template&id=1edec6d4"
import script from "./DeletedOrdersSnackbar.vue?vue&type=script&lang=js"
export * from "./DeletedOrdersSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports